import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  isEmptyObject,
  getLocalStorageObject,
  setLocalStorageObject,
} from "../../util/helper";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import RemoveIcon from '@mui/icons-material/Remove';
import { WindowScreenAction } from "../../redux/actions/brokerAction";


 

let localStorageObj = getLocalStorageObject("window-screen") || {
  screen: {},
};
const defscreen = {
     leftWindow:false,
     rightTopWindow:{
        updown:false,
        fullScreen:false
     },
     rightBottomWindow:{
        updown:false,
        fullScreen:false
     },
}
const ScreenAction = ({type,screenClick}) => {

 const dispatch = useDispatch();
 const [screen, setscreen] = useState(getLocalStorageObject("window-screen")?.screen || defscreen);
  

 useEffect(() => {
    dispatch(WindowScreenAction(screen));
}, [screen]);

  const screenClickFun = (key, value) => {
    
    screen[type][key] = value;
    screen.leftWindow = getLocalStorageObject("window-screen")?.screen?.leftWindow;
     
     setLocalStorageObject(
        "window-screen",
        'screen',
        screen,
        localStorageObj
      );
      setscreen(screen);
      dispatch(WindowScreenAction(screen));
      screenClick()
    
  }
 
  return (
    
        <div className="screen-ac d-flex justify-content-between px-2 mb-2">
            {!screen[type]['updown'] && !screen[type]['fullScreen'] && <RemoveIcon   className="icons" onClick={()=> screenClickFun('updown', true)} />}
            {(screen[type]['updown'] && !screen[type]['fullScreen']) && <KeyboardArrowUpIcon    className="icons" onClick={()=> screenClickFun('updown', false)} />}
            {screen[type]['fullScreen'] &&  <KeyboardArrowDownIcon    className="icons" onClick={()=> screenClickFun('fullScreen', false)} />}

           {!screen[type]['fullScreen'] && <FullscreenIcon className="icons" onClick={()=> screenClickFun('fullScreen', true)}/>}
           {screen[type]['fullScreen'] &&  <FullscreenExitIcon className="icons" onClick={()=> screenClickFun('fullScreen', false)}/>}
        </div>
  );
};

export default ScreenAction;
